/* =============================================================
   SULLIOS VAULT — sullios-vault.js
   Upload to: Online Store → Themes → Edit Code → Assets
   ============================================================= */

/* ── SHARED UTILITIES ── */
var SVUtil = {
  getCookie: function(name) {
    var match = document.cookie.match('(^| )' + name + '=([^;]+)');
    return match ? match[2] : null;
  },
  setCookie: function(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
  },
  deleteCookie: function(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }
};

/* =============================================================
   GATE PAGE — SVGate
   Handles email check, API call, cookie setting, redirect
   ============================================================= */
var SVGate = {

  init: function() {
    if (!document.getElementById('gateForm')) return;
    var emailEl = document.getElementById('gateEmail');
    if (emailEl) {
      emailEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') SVGate.check();
      });
    }
  },

  check: function() {
    var cfg     = window.SV_CONFIG || {};
    var emailEl = document.getElementById('gateEmail');
    var statusEl= document.getElementById('gateStatus');
    var btn     = document.getElementById('gateBtn');
    var icon    = document.getElementById('gateIcon');

    if (!emailEl) return;
    var email = emailEl.value.trim();

    // Basic validation
    emailEl.classList.remove('error', 'valid');
    if (!email || !email.includes('@') || !email.includes('.')) {
      emailEl.classList.add('error');
      statusEl.className = 'sv-gate-status fail';
      statusEl.textContent = 'Please enter a valid email address.';
      return;
    }

    // UI: checking state
    btn.disabled = true;
    btn.textContent = 'Checking...';
    icon.classList.add('checking');
    statusEl.className = 'sv-gate-status checking';
    statusEl.textContent = 'Checking your membership...';

    if (cfg.demoMode) {
      // DEMO MODE — any email ending @sullios.com gets access
      // Turn off in theme settings before going live
      setTimeout(function() {
        var granted = email.toLowerCase().endsWith('@sullios.com') ||
                      email.toLowerCase() === 'david@example.com';
        SVGate.handleResult(granted, email);
      }, 1500);
    } else {
      // PRODUCTION — call Cloudflare Worker
      fetch(cfg.workerUrl, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ email: email })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) { SVGate.handleResult(data.access === true, email); })
      .catch(function() {
        // Network error fallback
        icon.classList.remove('checking');
        btn.disabled = false;
        btn.textContent = 'Try again →';
        statusEl.className = 'sv-gate-status fail';
        statusEl.textContent = 'Something went wrong. Please try again.';
      });
    }
  },

  handleResult: function(granted, email) {
    var cfg      = window.SV_CONFIG || {};
    var icon     = document.getElementById('gateIcon');
    var emailEl  = document.getElementById('gateEmail');
    var statusEl = document.getElementById('gateStatus');
    var btn      = document.getElementById('gateBtn');
    var iconLock = document.getElementById('iconLock');
    var iconCheck= document.getElementById('iconCheck');
    var iconX    = document.getElementById('iconX');

    icon.classList.remove('checking');

    if (granted) {
      // ── ACCESS GRANTED ──
      icon.classList.add('success');
      if (iconLock)  iconLock.style.display  = 'none';
      if (iconCheck) iconCheck.style.display = 'block';
      emailEl.classList.add('valid');

      document.getElementById('gateForm').style.display = 'none';
      var h1 = document.getElementById('gateH1');
      if (h1) h1.innerHTML = 'Welcome<em>back.</em>';
      var intro = document.getElementById('gateIntro');
      if (intro) intro.style.display = 'none';
      document.getElementById('joinPrompt').classList.remove('visible');

      // Show unlocking animation
      var ul = document.getElementById('unlockingBlock');
      if (ul) {
        ul.classList.add('visible');
        setTimeout(function() {
          var bar = document.getElementById('unlockBar');
          if (bar) bar.style.width = '100%';
        }, 100);
      }

      // Set access cookie
      var cookieDays = cfg.cookieDays || 90;
      SVUtil.setCookie('ic_access', '1', cookieDays);

      // Store email for account display
      try { sessionStorage.setItem('sv_email', email); } catch(e) {}

      // Redirect to vault after bar fills
      setTimeout(function() {
        window.location.href = cfg.vaultUrl || '/pages/vault';
      }, 2200);

    } else {
      // ── ACCESS DENIED ──
      icon.classList.add('fail');
      if (iconLock) iconLock.style.display = 'none';
      if (iconX)    iconX.style.display    = 'block';
      emailEl.classList.add('error');
      statusEl.className = 'sv-gate-status fail';
      statusEl.textContent = "We don't recognise that email.";
      btn.disabled = false;
      btn.textContent = 'Try again →';
      document.getElementById('joinPrompt').classList.add('visible');

      // Reset icon after delay
      setTimeout(function() {
        icon.classList.remove('fail');
        if (iconX)    iconX.style.display    = 'none';
        if (iconLock) iconLock.style.display = 'block';
      }, 3000);
    }
  }

};


/* =============================================================
   VAULT PAGE — SVVault
   Handles tabs, countdown, drop states, voting, sign out
   ============================================================= */
var SVVault = {

  selectedStyleUrl: null,
  countdownTimer:   null,

  init: function() {
    if (!document.querySelector('.sv-vault')) return;

    SVVault.initTabs();
    SVVault.initCountdown();
    SVVault.initMemberDisplay();
  },

  /* ── TABS ── */
  initTabs: function() {
    var tabs = document.querySelectorAll('.sv-tab');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        SVVault.switchTab(tab.dataset.tab);
      });
    });
  },

  switchTab: function(name) {
    document.querySelectorAll('.sv-panel').forEach(function(p) { p.classList.remove('active'); });
    document.querySelectorAll('.sv-tab').forEach(function(t) { t.classList.remove('active'); });
    var panel = document.getElementById('panel-' + name);
    if (panel) panel.classList.add('active');
    var tab = document.querySelector('[data-tab="' + name + '"]');
    if (tab) tab.classList.add('active');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },

  /* ── COUNTDOWN & DROP STATE ── */
  initCountdown: function() {
    var cfg = window.SV_VAULT_CONFIG || {};
    if (!cfg.membersWindowEnd) return;

    var endTime = new Date(cfg.membersWindowEnd).getTime();

    function tick() {
      var now  = Date.now();
      var diff = endTime - now;

      if (diff > 0) {
        // Members window still open
        SVVault.setState('members');
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var hEl = document.getElementById('cd-h');
        var mEl = document.getElementById('cd-m');
        var sEl = document.getElementById('cd-s');
        if (hEl) hEl.textContent = String(h).padStart(2, '0');
        if (mEl) mEl.textContent = String(m).padStart(2, '0');
        if (sEl) sEl.textContent = String(s).padStart(2, '0');

      } else if (diff > -(7 * 24 * 3600000)) {
        // Window closed but drop not yet ended (within 7 days)
        clearInterval(SVVault.countdownTimer);
        SVVault.setState('public');

      } else {
        // Drop ended — more than 7 days ago
        clearInterval(SVVault.countdownTimer);
        SVVault.setState('closed');
      }
    }

    tick();
    SVVault.countdownTimer = setInterval(tick, 1000);
  },

  setState: function(state) {
    var badge     = document.getElementById('dropBadge');
    var badgeText = document.getElementById('badgeText');
    var tagline   = document.getElementById('dropTagline');
    var countdown = document.getElementById('countdownBlock');
    var pubNotice = document.getElementById('publicNotice');
    var clsNotice = document.getElementById('closedNotice');
    var addBtn    = document.getElementById('addToBagBtn');
    var styleList = document.getElementById('styleList');
    var cfg       = window.SV_VAULT_CONFIG || {};

    if (!badge) return;

    // Reset
    badge.className = 'sv-drop-badge';
    if (countdown) countdown.style.display = 'none';
    if (pubNotice) pubNotice.style.display = 'none';
    if (clsNotice) clsNotice.style.display = 'none';

    if (state === 'members') {
      badge.classList.add('members');
      if (badgeText) badgeText.textContent = 'Members early access';
      if (countdown) countdown.style.display = 'block';
      if (addBtn) { addBtn.disabled = false; addBtn.textContent = cfg.addToBagLabel || 'Add to bag →'; }
      if (styleList) styleList.querySelectorAll('.sv-style-row:not(.sv-sold-out)').forEach(function(r) { r.style.pointerEvents = ''; r.style.opacity = ''; });

    } else if (state === 'public') {
      badge.classList.add('public');
      if (badgeText) badgeText.textContent = 'Now live publicly';
      if (pubNotice) pubNotice.style.display = 'flex';
      if (addBtn) { addBtn.disabled = false; addBtn.textContent = cfg.addToBagLabel || 'Add to bag →'; }

    } else if (state === 'closed') {
      badge.classList.add('closed');
      if (badgeText) badgeText.textContent = 'Drop closed';
      if (clsNotice) clsNotice.style.display = 'block';
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Drop closed'; }
      if (styleList) styleList.querySelectorAll('.sv-style-row').forEach(function(r) { r.style.opacity = '0.35'; r.style.pointerEvents = 'none'; });
    }
  },

  /* ── STYLE SELECTION ── */
  selectStyle: function(el) {
    if (el.classList.contains('sv-sold-out')) return;
    document.querySelectorAll('.sv-style-row').forEach(function(r) { r.classList.remove('sel'); });
    el.classList.add('sel');
    SVVault.selectedStyleUrl = el.dataset.url || null;
  },

  /* ── ADD TO BAG ── */
  addToBag: function() {
    var selectedRow = document.querySelector('.sv-style-row.sel');
    if (!selectedRow) return;
    var url = selectedRow.dataset.url;
    if (url) {
      window.location.href = url;
    } else {
      // Fallback: go to main drop product
      var cfg = window.SV_VAULT_CONFIG || {};
      if (cfg.dropProductUrl) window.location.href = cfg.dropProductUrl;
    }
  },

  /* ── VIEW FULL PRODUCT ── */
  viewProduct: function() {
    var cfg = window.SV_VAULT_CONFIG || {};
    if (cfg.dropProductUrl) window.location.href = cfg.dropProductUrl;
  },

  /* ── VOTE ── */
  castVote: function(el) {
    document.querySelectorAll('.sv-vote-opt').forEach(function(o) { o.classList.remove('voted'); });
    el.classList.add('voted');
    // In production: POST vote to a Cloudflare Worker or Shopify metafield endpoint
    // fetch('/apps/sullios-vote', { method: 'POST', body: JSON.stringify({ option: el.querySelector('.sv-vote-opt-text').textContent }) })
  },

  /* ── MEMBER DISPLAY ── */
  initMemberDisplay: function() {
    try {
      var email = sessionStorage.getItem('sv_email') || '';
      if (email) {
        var name = email.split('@')[0];
        name = name.charAt(0).toUpperCase() + name.slice(1);
        var nameEl   = document.getElementById('memberName');
        var accountEl= document.getElementById('accountName');
        var avatarEl = document.getElementById('memberAvatar');
        if (nameEl)   nameEl.textContent   = name;
        if (accountEl)accountEl.textContent = name;
        if (avatarEl) avatarEl.textContent  = name.charAt(0).toUpperCase();
      }
    } catch(e) {}
  },

  /* ── SIGN OUT ── */
  signOut: function() {
    SVUtil.deleteCookie('ic_access');
    try { sessionStorage.removeItem('sv_email'); } catch(e) {}
    var cfg = window.SV_VAULT_CONFIG || {};
    window.location.href = cfg.gateUrl || '/pages/vault-gate';
  }

};


/* ── INIT ON DOM READY ── */
document.addEventListener('DOMContentLoaded', function() {
  SVGate.init();
  SVVault.init();
});